import { ReactComponent as CloseButton } from '../../../../assets/CaretDoubleRight.svg';
import { useDispatch, useSelector } from 'react-redux'
import { ReactComponent as Chats } from '../../../../assets/Chats.svg';
import classes from './SidebarHeader.module.css'
import { toggle } from '../sidebarSlice';

function SidebarHeader() {
    const sidebarState = useSelector(state => state.sidebar)
    const dispatch = useDispatch()
    let sidebarHeader = (
        <div className={classes.SidebarHeader}>
            <div className={classes.CloseButton} onClick={() => dispatch(toggle({isOpen: false}))}>
            <CloseButton/>
            </div>
            <div className={classes.Chats}>
                <div>כל השיחות</div>
                <div className={classes.ChatsButton}>
                    <Chats/>
                </div>
            </div>
        </div>
    )
    if (!sidebarState.isOpen)(
        sidebarHeader = (
            <div className={classes.SidebarHeaderClosed} onClick={() => dispatch(toggle({isOpen: true}))}>
                <div className={classes.ChatsButton}>
                    <Chats/>
                </div>
            </div>
        )
    )
    return (
        sidebarHeader
    );
}

export default SidebarHeader;
